import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceConfiguracaoAlarme from "../../../../services/serviceConfiguracaoAlarme";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogNew({ open, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [tipoDataOptions, setTipoDataOptions] = useState<any[]>([]);

    const validationSchema = yup.object().shape({
        tipoAlarmeID: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        assunto: yup.string().required(messages.requiredField),
        descricao: yup.string().required(messages.requiredField),
        template: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            tipoAlarmeID: "",
            assunto: "",
            descricao: "",
            template: "",
        },
    });

    useEffect(() => {
        setDataTipo();
    }, []);

    const setDataTipo = () => {
        serviceConfiguracaoAlarme
            .getAllTipoAlarme(null)
            .then((result) => {
                if (result) {
                    setTipoDataOptions(result.data);
                }
            })
            .catch(() => {
                setTipoDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        const newItem = {
            ...values,
        };

        serviceConfiguracaoAlarme
            .create(newItem)
            .then((result) => {
                if (result) {
                    toast.success(messages.createSucess);
                    onClose(true);
                    reset();
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.createError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Nova Configuração de Alarme
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                name="tipoAlarmeID"
                                label="Tipo"
                                options={tipoDataOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="assunto"
                                label="Assunto"
                                control={control}
                                error={errors}
                                maxLength={100}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="descricao"
                                label="Descrição"
                                control={control}
                                error={errors}
                                maxLength={100}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput name="template" label="Template" control={control} error={errors} multiline />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
